import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './theme/base.css';
import { App } from './App';
import { ToastProvider } from './components/toast/ToastContext';
import { ToastViewport } from './components/toast/ToastViewport';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ToastProvider>
        <App />
        <ToastViewport />
      </ToastProvider>
    </BrowserRouter>
  </StrictMode>
);
